export default "__VITE_ASSET__Npoq2rcz__"